<li style="list-style: none; padding-bottom: 4px;"></li>
<mat-form-field [appearance]="appearance" [ngClass]="{
    'minwidth': !!minWidth,
    'full-width': !minWidth
  }" [ngStyle]="{
    width: customWidth,
    'min-width': minWidth ? minWidth : null
  }">
  <mat-label>{{placeholder}}</mat-label>
  <input matInput formart [matDatepicker]="picker" [formControl]="dateControl" (dateChange)="onDateChange($event)"
    [readonly]="readonly ? true : null" [max]="maxDate" [min]="datestring ? datestring : null" placeholder="mm/dd/yyyy">
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-error *ngIf="dateControl.hasError('required')">
    {{error}}
  </mat-error>

</mat-form-field>